module.exports = __webpack_public_path__ + "img/3.ad547e6c.jpg";